// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type EntityPageUpdateCoverMutationVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  coverMediaType: Types.EntityPageCoverMediaType;
  coverMediaUploadId?: Types.InputMaybe<Types.Scalars['UploadId']['input']>;
  originalCoverMediaUploadId?: Types.InputMaybe<
    Types.Scalars['UploadId']['input']
  >;
}>;

export type EntityPageUpdateCoverMutation = {
  __typename?: 'Mutation';
  entityPageUpdateCover?: {
    __typename?: 'EntityPageMutationResult';
    error?: {
      __typename?: 'EntityPagesMutationError';
      errorType: string;
      errorCode: number;
    } | null;
  } | null;
};

export const EntityPageUpdateCoverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EntityPageUpdateCover' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'coverMediaType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EntityPageCoverMediaType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'coverMediaUploadId' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UploadId' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'originalCoverMediaUploadId' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UploadId' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPageUpdateCover' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entityPageId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'coverMediaType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'coverMediaType' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'coverMediaUploadId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'coverMediaUploadId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'originalCoverMediaUploadId',
                      },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'originalCoverMediaUploadId',
                        },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPageUpdateCoverMutation,
  EntityPageUpdateCoverMutationVariables
>;
